import { getEnuData, getBtns } from '@/api/common'
import { getListData, delData } from '@/api/common'
import { formatDate, formatDate1 } from './util'

export default {
    data() {
        return {
            loading: true,
            current: 1,
            pagesize: 20,
            total: 0,
            selectData: [],
            sortData: {
                prop: '',
                order: ''
            },
            tableData: [],
            enu_obj: {},
            enu_name: [],
            main_btns: [],
            lab_btns: [],
            label_showids: '',
            btn_showids: '',
            editshow: false,
            infoshow: false,
            edit_title: '',
            model_id: -1,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            search_type: 1,
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        selectChanges(selection) {
            this.selectData = selection;
        },
        loadOtherData() {
            //加载其他内容， 可重写
        },
        initPageParams() {
            this.search_Obj["pageNum"] = this.current;
            this.search_Obj["pageSize"] = this.pagesize;
            if (this.sortData.prop != '') {
                this.search_Obj["sorterName"] = this.sortData.prop;
                this.search_Obj["sorterDirection"] = this.sortData.order;
            }
            this.loadOtherData();
        },
        async getData() {
            this.initPageParams();  //初始化分页参数
            this.getBtnsData();     //按钮权限数据
            if (this.enu_name.length > 0) {
                await this.initEnuData();     //初始化枚举
            }
            this.getListData();     //加载列表数据
        },
        initEnuData() {
            return new Promise((resolve) => {
                getEnuData(this.enu_name).then(res => {
                    if (res.code == 1) {
                        let enu_array = res.data
                        for (let i = 0; i < enu_array.length; i++) {
                            let e_obj = enu_array[i];
                            let vals = e_obj.values;
                            let diss = e_obj.displays;
                            let e_Map_Obj = {};
                            let e_Map_Obj1 = [];
                            for (let j = 0; j < (vals.length < diss.length ? vals.length : diss.length); j++) {
                                e_Map_Obj[vals[j]] = diss[j]
                                e_Map_Obj1[j] = vals[j] + ',' + diss[j]
                            }
                            this.enu_obj[e_obj.name] = e_Map_Obj;
                            this.enu_obj[e_obj.name + 'order_data'] = e_Map_Obj1;
                        }
                        resolve();
                        return
                    }
                })
            })
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    // this.sortData.prop = 'name'
                    // if(res.data.sorterDirection == "DESC"){
                    //     this.sortData.order = "descending";
                    // } else {
                    //     this.sortData.order = "ascending";
                    // }
                }
            })
        },
        getBtnsData() {
            this.main_btns = []
            this.lab_btns = []
            getBtns(this.menu_id).then(res => {
                if (res.code == 1) {
                    this.main_btns = res.data.btnList
                    this.lab_btns = res.data.labList
                }
            })
        },
        doSearch() {
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getListData()
        },
        pageChange(page) {
            this.current = page
            this.search_Obj["pageNum"] = this.current;
            this.getListData();
        },
        handleSizeChange(val){
            this.pagesize = val
            this.search_Obj["pageSize"] = this.pagesize;
            this.pageChange(1)
        },
        sortChange(column) {
            if (this.$isNull(column.order)) {
                this.search_Obj["sorterName"] = "id";
                this.search_Obj["sorterDirection"] = "DESC";
            } else {
                this.sortData.prop = column.prop
                this.sortData.order = column.order
                this.search_Obj["sorterName"] = this.sortData.prop;
                this.search_Obj["sorterDirection"] = this.sortData.order;
            }
            this.getListData();
        },
        transEnu(val, enum_name) {
            let enuInfo = this.enu_obj[enum_name];
            if (enuInfo != undefined) {
                let dis = enuInfo[val];
                return dis;
            } else {
                return val;
            }
        },
        enuObj(enum_name) {
            let enuInfo = this.enu_obj[enum_name + 'order_data'];
            let arr = [];
            if (enuInfo != undefined) {
                var values = Object.values(enuInfo);
                for (let i = 0; i < values.length; i++) {
                    let str = values[i].split(",")
                    let temp = {};
                    temp["key"] = str[0]
                    temp["title"] = str[1]
                    arr.push(temp)
                }
            }
            return arr
        },
        btnClick(params) {
            this[params]();
        },
        labelClick(params) {
            this[params.func](params.index, params.row);
        },
        add() {
            this.model_id = -1
            this.edit_title = "添加" + this.m_name
            this.editshow = true
        },
        edit(index, row) {
            this.edit_title = "编辑" + this.m_name
            this.model_id = row.id
            this.editshow = true
        },
        info(index, row) {
            this.model_id = row.id
            this.infoshow = true
        },
        del(index, row) {
            this.$confirm('确定要删除该条数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del_Obj.data.ids = row.id
                delData(this.del_Obj).then(res => {
                    if (res.code == 1) {
                        this.$msgs(res.msg)
                        this.getListData();
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
        delAll() {
            if (this.selectData.length <= 0) {
                this.$msg("请选择要删除的数据")
            } else {
                this.$confirm('确定要删除选中的数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '';
                    for (let data of this.selectData) {
                        if (ids === '') {
                            ids = data.id + "";
                        } else {
                            ids += "," + data.id;
                        }
                    }
                    this.del_Obj.data.ids = ids
                    delData(this.del_Obj).then(res => {
                        if (res.code == 1) {
                            this.$msgs(res.msg)
                            this.getListData();
                        } else {
                            this.$msg(res.msg)
                        }
                    })
                }).catch(() => { })
            }
        },
        closeEditDialog() {
            this.editshow = false
        },
        closeInfoDialog() {
            this.infoshow = false
        },
        saveOk() {
            this.editshow = false
            this.getListData()
        },
        formatDate(date, fmt){
            return formatDate(date, fmt)
        },
        formatDate1(date, fmt){
            return formatDate1(date, fmt)
        },
        removeEmptyChild(data){
            data.forEach(v => {
                if (v.children.length==0) {
                    v.children = null
                }else{
                    this.removeEmptyChild(v.children)
                }
            })
            return data
        },
        dragControllerDiv: function(resizeBox, resizeHandle, moveDiv) {
            const handleWidth = resizeHandle.offsetWidth || 10
            const getRightBox = () => {
                let node = resizeHandle.nextElementSibling
                if (node === moveDiv) {
                    node = node.nextElementSibling
                }
                return node
            }
            const applyWidth = (width) => {
                const parent = resizeBox.parentElement
                const parentWidth = parent ? parent.clientWidth : document.documentElement.clientWidth
                const minLeftWidth = 150
                const minRightWidth = 200
                const maxLeftWidth = parentWidth - handleWidth - minRightWidth
                const nextWidth = Math.max(minLeftWidth, Math.min(width, maxLeftWidth))
                resizeBox.style.width = nextWidth + 'px'
                const rightBox = getRightBox()
                if (rightBox) {
                    rightBox.style.width = `calc(100% - ${nextWidth + handleWidth}px)`
                }
                return nextWidth
            }

            //鼠标按下事件
            resizeHandle.onmousedown = e => {
                e.preventDefault()
                moveDiv.style.display = "block"
                const startX = e.clientX
                const startWidth = resizeBox.offsetWidth
                let lastX = startX
                moveDiv.style.left = startX + "px"

                //鼠标拖动事件
                document.onmousemove = ev => {
                    lastX = ev.clientX
                    moveDiv.style.left = lastX + "px"
                }
                // 鼠标松开事件
                document.onmouseup = function() {
                    applyWidth(startWidth + (lastX - startX))
                    document.onmousemove = null
                    document.onmouseup = null
                }
            }
        },
        handleMouseUp(){
            this.$refs.moveDiv.style.display = "none"
        },
        changeSearchType(type){
            this.search_type = type
        }
    }
}